function ClientMarketingConsentPage() {
  return (
    <main
      className="min-h-screen px-6 py-8 md:px-10 md:py-10"
      style={{
        background:
          'radial-gradient(circle at 8% 0%, #dcfce7 0, transparent 30%), radial-gradient(circle at 100% 10%, #dbeafe 0, transparent 34%), linear-gradient(160deg, #f8fafc 0%, #eef2ff 100%)',
      }}
    >
      <div className="mx-auto w-full max-w-[980px]">
        <section className="rounded-3xl border border-[#dbe4f4] bg-white/90 p-6 shadow-[0_12px_30px_rgba(15,23,42,0.06)]">
          <p className="m-0 inline-block rounded-full bg-[#111827] px-3 py-1 text-xs font-bold tracking-[0.08em] text-white">
            MARKETING CONSENT
          </p>
          <h1 className="mt-3 text-[clamp(24px,4.5vw,34px)] font-semibold leading-tight tracking-[-0.03em] text-[#0f172a]">
            마케팅 정보 수신 동의 안내
          </h1>
          <p className="mt-2 text-xs text-[#667085]">
            시행일: 2026-03-06 | 버전: v1.0
          </p>
        </section>

        <section className="mt-6 space-y-4 rounded-3xl border border-[#dbe4f4] bg-white/90 p-6 text-sm leading-7 text-[#344054] shadow-[0_12px_30px_rgba(15,23,42,0.06)]">
          <article>
            <h2 className="m-0 text-base font-semibold text-[#101828]">1. 동의 여부</h2>
            <p className="mt-2">
              마케팅 정보 수신 동의는 선택사항입니다. 동의하지 않아도 기본 서비스 이용에는 제한이
              없습니다.
            </p>
          </article>

          <article>
            <h2 className="m-0 text-base font-semibold text-[#101828]">
              2. 수신 목적
            </h2>
            <p className="mt-2">
              신규 기능 안내, 이벤트/프로모션 안내, 서비스 개선 소식 전달을 목적으로 합니다.
            </p>
          </article>

          <article>
            <h2 className="m-0 text-base font-semibold text-[#101828]">
              3. 수신 항목 및 채널
            </h2>
            <p className="mt-2">
              이메일, 앱 푸시 알림, 서비스 내 공지/배너를 통해 마케팅 정보를 전달할 수 있습니다.
            </p>
          </article>

          <article>
            <h2 className="m-0 text-base font-semibold text-[#101828]">4. 보유 및 이용 기간</h2>
            <p className="mt-2">
              마케팅 수신 동의일로부터 회원 탈퇴 또는 동의 철회 시까지 보유/이용합니다.
            </p>
          </article>

          <article>
            <h2 className="m-0 text-base font-semibold text-[#101828]">
              5. 동의 철회 방법
            </h2>
            <p className="mt-2">
              설정 페이지에서 수신 설정 변경이 가능하며, 고객센터(support@ahshoot.kr)로도 철회
              요청할 수 있습니다.
            </p>
          </article>

          <article>
            <h2 className="m-0 text-base font-semibold text-[#101828]">
              6. 관련 고지
            </h2>
            <p className="mt-2">
              관계 법령 또는 서비스 정책에 따른 필수 안내(약관/정책 변경, 보안 공지 등)는 마케팅
              수신 동의 여부와 무관하게 발송될 수 있습니다.
            </p>
          </article>

          <article className="rounded-xl border border-[#eaecf0] bg-[#f8fafc] px-4 py-3 text-xs leading-6 text-[#667085]">
            실제 운영 정책은 서비스 기능 및 관계 법령 변경에 따라 업데이트될 수 있습니다.
          </article>
        </section>
      </div>
    </main>
  );
}

export default ClientMarketingConsentPage;
